/* eslint-disable no-new */
import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);
const starsSlider = document.querySelector('.main__stars-slider');
const slideTextWrapper = document.querySelector('.main__stars-slider-text');
const names = [];
const params = {
	direction: 'horizontal',
	speed: 750,
	loop: true,
	spaceBetween: 20,
	slidesPerView: 1,
	loopedSlides: 2,
	allowTouchMove: false,
	pagination: {
		el: '.main__stars-slider-pagination',
		clickable: true,
		renderBullet: (index, className) => {
			return `<span class="${className}">${names[index]} / </span>`;
		},
	},
	navigation: {
		nextEl: '.main__stars-slider-button-next',
		prevEl: '.main__stars-slider-button-prev',
	},
	breakpoints: {
		320: {
			allowTouchMove: true,
		},
		1025: {
			allowTouchMove: false,
		},
	},
};

function setActiveText(sliderWraper) {
	const activeSlide = sliderWraper[0].querySelector('.swiper-slide-active .main__stars-slide-text').innerText;
	slideTextWrapper.innerText = activeSlide;
}

function init() {
	if (starsSlider) {
		document.querySelectorAll('.swiper-slide.main__stars-slide').forEach((el) => {
			names.push(el.dataset.people);
		});

		const slider = new Swiper(starsSlider, params);
		const sliderWraper = slider.$wrapperEl;

		slider.on('slideChange', () => {
			setTimeout(() => {
				setActiveText(sliderWraper);
			}, 100);
		});

		setActiveText(sliderWraper);
	}
}

export default {
	init,
};
